<template lang="html">
<el-container>
  <el-header class="main-body-search">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="pager.fuzzyText"
            placeholder="模糊查询" @keyup.enter.native="searchMain(1)">
            <el-button slot="append" icon="el-icon-search" @click="searchMain(1)"></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="18">
          <el-button type="primary" icon="el-icon-plus" @click="openDialog(ACTION.ADD)">新增</el-button>
        </el-col> -->
      </el-row>
  </el-header>
  <el-main class="main-body-table">
    <el-table :data="mainTableData" @sort-change="sortChange">
      <el-table-column
        prop="clientId"
        label="客户端ID"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="appFullName"
        label="应用全称"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="appVersion"
        label="应用版本"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="appPlatformDictValue"
        label="手机平台类型"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="osVersion"
        label="操作系统版本"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="deviceId"
        label="设备ID"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="userAccount"
        label="用户名称"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column
        prop="userTag"
        label="用户标签"
        align="center"
        sortable="custom">
      </el-table-column>
      <el-table-column label="操作" width="90" align="center">
        <template slot-scope="scope">
          <i class="el-icon-view icon-button" title="查看" @click="openDialog(ACTION.VIEW, scope.row, scope.$index)"></i>
          <i class="el-icon-edit icon-button" title="编辑" @click="openDialog(ACTION.EDIT, scope.row, scope.$index)"></i>
          <i class="el-icon-delete icon-button" title="删除" @click="deleteRow(scope.row, scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
    <!--分页工具条-->
    <el-pagination class="main-body-table-page" layout="total, sizes, prev, pager, next, jumper"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"
      :current-page="pager.current" :page-size="pager.size" :total="total">
    </el-pagination>
  </el-main>
  <el-dialog width="50%" :title="this.currentAction.name + '客户端与应用及用户关系信息'" :visible.sync="detailDialogVisible"
    @close="closeDialog" :before-close="beforeClose" v-dialogDrag>
    <el-form ref="formRef" :rules="formRules" :model="formModel" :disabled="currentAction.value === 3" label-width="111px">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="客户端ID" prop="clientId">
            <el-input v-model="formModel.clientId" maxlength="80" disabled></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="应用全称" prop="appId">
            <el-select v-model="formModel.appId" style="width:300px" disabled>
              <el-option
                v-for="item in appIdOptions"
                :key="item.appId"
                :label="item.appFullName"
                :value="item.appId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="应用全称" prop="appFullName">
            <el-input v-model="formModel.appFullName" maxlength="30" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="应用版本" prop="appVersion">
            <el-input v-model="formModel.appVersion" maxlength="30" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机平台类型" prop="appPlatform">
            <el-radio-group v-model="formModel.appPlatform" disabled>
              <el-radio v-for="item in appPlatformDicts" :key="item.itemCode" :label="item.itemCode">
                {{item.value}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="操作系统版本" prop="osVersion">
            <el-input v-model="formModel.osVersion" maxlength="50" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备ID" prop="deviceId">
            <el-input v-model="formModel.deviceId" maxlength="80" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户名称" prop="userAccount">
            <el-input v-model="formModel.userAccount" maxlength="80" disabled></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="24">
          <el-form-item label="用户名称" prop="userId">
            <el-select v-model="formModel.userId" disabled>
              <el-option
                v-for="item in userIdOptions"
                :key="item.id"
                :label="item.userAccount"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="用户标签" prop="userTag">
            <el-tooltip :content="'仅用于按用户标签推送消息, 多个标签以逗号分隔, 最多允许10个标签, 注意:每个用户在6小时内只能设置一次'" placement="bottom">
              <el-input v-model="formModel.userTag" maxlength="500" placeholder="请输入用户标签, 多个以逗号分隔, 最大长度500"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="currentAction.value !== 3" @click="saveForm()" type="primary">保存</el-button>
      <el-button @click.native="closeDialog()">关闭</el-button>
    </span>
  </el-dialog>
</el-container>
</template>

<script>
import { getDictItemsByTypeNames } from '@/views/common/api/Index'
import {
  selectListAppInfo
} from '../../../api/sys/getui/AppInfo'
import {
  selectPageByFuzzyClientAppUser,
  insertClientAppUser,
  updateAllColumnClientAppUser,
  deleteByIdClientAppUser
} from '../../../api/sys/getui/ClientAppUser'
export default {
  data() {
    return {
      // 操作类型常量
      ACTION: {
        ADD: { value: 1, name: '新增' },
        EDIT: { value: 2, name: '修改' },
        VIEW: { value: 3, name: '查看' }
      },
      // 当前操作类型, ACTION.ADD/ACTION.VIEW/ACTION.EDIT
      currentAction: {},
      // 主表记录总数
      total: 0,
      // 分页及查询对象
      pager: {
        current: 1,
        size: 10,
        fuzzyText: ''
      },
      // 主表数据
      mainTableData: [],
      // 表单模型
      formModel: {},
      // 表单验证规则
      formRules: {
        clientId: [{ required: false, message: '请输入客户端ID', trigger: 'blur' }],
        // appId: [{ required: true, message: '请输入应用全称', trigger: 'blur' }],
        // appVersion: [{ required: true, message: '请输入应用版本', trigger: 'blur' }],
        // appPlatform: [{ required: true, message: '请输入手机平台类型', trigger: 'blur' }],
        // osVersion: [{ required: true, message: '请输入操作系统版本', trigger: 'blur' }],
        // deviceId: [{ required: true, message: '请输入设备ID', trigger: 'blur' }],
        delete_this_line: []
      },
      // 外键数据列表: 应用全称
      appIdOptions: [],
      // 外键数据列表: 用户名称
      userIdOptions: [],
      // 字典数据列表: 手机平台类型
      appPlatformDicts: [],
      // 对话框显示隐藏控制
      detailDialogVisible: false
    }
  },
  // 页面首次加载数据
  mounted() {
    this.searchMain(1)
    this.loadDict(['app-platform-type'])
  },
  methods: {
    /**
     * 点击列标题排序
     * @param column 点击排序的列对象
     */
    sortChange: function(column) {
      this.pager.prop = column.prop
      if (column.prop === 'appPlatformDictValue') {
        this.pager.prop = 'appPlatform'
      }
      this.pager.order = column.order
      this.searchMain(1)
    },
    /**
     * 主表每页记录数调整后的查询
     * @param size int 调整后的每页记录数
     */
    handleSizeChange(size) {
      this.pager.size = size
      this.searchMain()
    },
    /**
     * 主表翻页查询
     * @param current int 指定查询页号
     */
    handleCurrentChange(current) {
      this.pager.current = current
      this.searchMain()
    },
    /**
     * 分页模糊查询
     * @param current int 可选参数，查询指定页的数据
     * current: 不传值或传null/undefined/0，表示翻页
     * current: 大于等于1表示重新查询该页
     *    例如：更新某记录后重新加载当前页
     *    例如：删除某记录、查询文本框回车、查询按钮点击则传1，重新查询第1页
     */
    searchMain(current) {
      if (current && current >= 1) {
        // 重新查询该页
        this.pager.current = current
      }
      this.fetchMainTable()
    },
    /**
     * 模糊查询主表数据
     */
    fetchMainTable() {
      selectPageByFuzzyClientAppUser(this.pager).then(res => {
        let { data } = res
        this.total = data.total
        this.mainTableData = data.records
        this.setDictValueColumn()
      })
    },
    /**
     * 设置主表数据集合中字典itemCode列的字典值列
     */
    setDictValueColumn() {
      if (this.mainTableData && this.mainTableData.length > 0) {
        this.mainTableData.forEach(row => {
          row.appPlatformDictValue = this.findDictItemValueByItemCode(
            row.appPlatform,
            this.appPlatformDicts
          )
        })
        // 使数组的更新被VUE检测到
        this.mainTableData.push({})
        this.mainTableData.pop()
      }
    },
    /**
     * 保存表单
     */
    saveForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          this.$message.error('请补全缺失的信息!')
          return
        }
        // 表单校验成功
        if (this.currentAction.value === 1) {
          this.insert()
        } else {
          this.updateAllColumn()
        }
      })
    },
    /**
     * 新增插入记录
     */
    insert() {
      insertClientAppUser(this.formModel).then(res => {
        this.closeDialog()
        this.searchMain(1)
      })
    },
    /**
     * 全部字段覆盖更新
     */
    updateAllColumn() {
      updateAllColumnClientAppUser(this.formModel).then(res => {
        if (res.code === 20000) {
          this.closeDialog()
          this.searchMain()
        }
      })
    },
    /**
     * 删除该行记录
     * @param row 行记录对象
     * @param index 行索引号
     */
    deleteRow(row, index) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteByIdClientAppUser({ id: row.id }).then(res => {
            this.searchMain(1)
          })
        })
        .catch(() => {})
    },
    /**
     * 打开对话框
     * @param action ACTION.ADD/ACTION.VIEW/ACTION.EDIT
     * @param row 行记录对象，新增时为空
     * @param indexOfRow 行索引号，新增时为空
     */
    openDialog(action, row, indexOfRow) {
      this.formModel = Object.assign({}, row || this.getDefaultFormModel())
      this.currentAction = action
      if (this.appIdOptions && this.appIdOptions.length > 0) {
        // 已经加载外键列表数据，可以直接弹出对话框
        this.detailDialogVisible = true
        return
      }
      selectListAppInfo({}).then(res => {
        this.appIdOptions = res.data
        this.detailDialogVisible = true
      })
    },
    /**
     * 设置新增对话框表单中的默认值
     * @returns 默认值对象
     */
    getDefaultFormModel() {
      return {
        appPlatform: this.appPlatformDicts[0].itemCode
        // orgId: this.orgIdOptions[0].id
      }
    },
    /**
     * 异步加载数据字典
     * @param typeNames 字典类型名称数组
     * @param dicts 接收字典结果数组数据
     */
    loadDict(typeNames) {
      getDictItemsByTypeNames({
        lsStrings: typeNames
      }).then(res => {
        this.appPlatformDicts = res.data['app-platform-type']
        this.setDictValueColumn()
      })
    },
    /**
     * 根据itemCode从字典项列表dicts查找对应记录的value并返回
     * @param itemCode 字典项编码
     * @param dicts 字典项列表
     * @returns 字典value
     */
    findDictItemValueByItemCode(itemCode, dicts) {
      for (let i = 0, len = dicts.length; i < len; i++) {
        if (itemCode === dicts[i].itemCode) {
          return dicts[i].value
        }
      }
      return ''
    },
    /**
     * 关闭对话框
     */
    closeDialog() {
      if (this.beforeCloseCheck()) {
        this.detailDialogVisible = false
      }
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done()
      }
    }
  }
}
</script>
<style lang="css">
</style>
